import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { IPayScale } from '../../pay-scales.types';

/**
 * Handles display of pay tables setting card
 */
@Component({
	selector: 'app-pay-scales-settings-card',
	templateUrl: './pay-scales-settings-card.component.html'
})
export class PayScalesSettingsCardComponent implements OnInit {
	@Input() public payScale: IPayScale;
	@Output() public onChange: EventEmitter<IPayScale> = new EventEmitter();

	/**
	 * ngOnInit
	 */
	public ngOnInit(): void {
		if (!this.payScale) {
			return;
		}
	}

	/**
	 * isNeedChange
	 */
	public isNeedChange(): void {
		this.onChange.emit(this.payScale);
	}
}
